import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import apiClient from "../../utils/api";

const GoogleRedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();



  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    if (token) {
      // store token in localStorage
      localStorage.setItem('authToken', token);
    } else {
      console.error("No token found in the URL");
    }

    const fetchUserProfile = async () => {
      try {
        const response = await apiClient.authControllerGetProfile();
        const email = response.email;
        const consentStatus = await apiClient.consentControllerGetConsentStatus();
        console.log('consent', consentStatus);
        console.log('consent type', typeof consentStatus); // gives string
        const convertedConsentStatus = typeof consentStatus == 'string'? consentStatus === 'true' : consentStatus;
        console.log('converted consent', convertedConsentStatus);
        console.log('converted consent type', typeof convertedConsentStatus); // gives boolean
        if (email) {
          login({ username: email, consent: convertedConsentStatus});
        } else {
          alert("Cannot get email from google account, please contact admin kn2132@nyu.edu");
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching email:", error);
        alert("Login Failed, please contact admin kn2132@nyu.edu");
        navigate("/");
      }
    };

    fetchUserProfile();
  }, [location, login, navigate]);


  return <div>Loading...</div>;
};

export default GoogleRedirectHandler;
